<div class="accordion-header">
  <ng-content select="[accordion-header]"></ng-content>

  <div *ngIf="showButtons">
    <img [src]="iconService.Icon.down_1_5" class="arrow-img" *ngIf="!isOpen" (click)="expandAll()" />
    <img [src]="iconService.Icon.up_1_5" class="arrow-img" *ngIf="isOpen" (click)="collapseAll()" />
  </div>
</div>
<div class="divider" *ngIf="isOpen"></div>
<div class="accordion-body" *ngIf="isOpen" [@inOutAnimation]>
  <ng-content select="[accordion-body]"></ng-content>
</div>
